<template>
  <div class="login notranslate">
    <div class="loginFrame">
      <h1>{{locale.login_title}}</h1>
      <h2 v-if="authId">{{locale.login_subtitle_pwonly}}</h2>
      <h2 v-else>{{locale.login_subtitle}}</h2>
      <form @submit.prevent="onSubmit" class="loginForm">
        <div v-if="!authId" class="uid"><input type="text" class="input" id="uid" placeholder="id" v-model="uid" required></div>
        <div class="upw"><input type="password" class="input" id="upw" placeholder="password" v-model="password" required></div>
        <div><button type="submit" class="btn btnFull btnPrimary">LOGIN</button></div>
      </form>
    </div>
    <div v-if="toastList">
      <Toast v-for="toast in toastList"
        :locale="locale"
        :key="toast.id"
        :toast="toast"
        @confirm="toastConfirm" />
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import Toast from '@/components/Util/Toast'
let routeHistory

export default {
  name: 'Login',
  props: [
    'ln',
    'locale',
    'isPublic'
  ],
  components: {
    Toast
  },
  computed: {
    auth () {
      return this.$store.getters['authentication/getAuthInfo']
    },
    authId () {
      return this.$store.state.authentication.loginId
    },
    isBlank () {
      return regExp.replaceAllEmpty(this.uid).trim().length === 0 || regExp.replaceAllEmpty(this.password).length === 0
    }
  },
  mounted () {
    const uid = document.getElementById('uid')
    const upw = document.getElementById('upw')
    if (uid) {
      uid.focus()
    } else if (upw) {
      upw.focus()
    }
    if (this.authId) {
      this.uid = this.authId
    }
    if (routeHistory) {
      this.historyBack = routeHistory
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.name) {
      routeHistory = {
        name: from.name,
        params: from.params
      }
    }
    next()
  },
  created () {
    this.$store.commit('authentication/setLogin', false)
  },
  data () {
    return {
      uid: '',
      password: '',
      message: false,
      historyBack: null,
      toastList: []
    }
  },
  methods: {
    addToast (trigger, type, message, otherData) {
      const id = UNIQUE.mid()
      const toast = {
        id: id,
        type: type,
        trigger: trigger,
        message: message,
        ...otherData
      }
      this.toastList.push(toast)
    },
    delToast (id) {
      this.toastList = id ? this.toastList.filter(x => x.id !== id) : []
    },
    toastConfirm (data) {
      const trigger = this.toastList.find(x => x.id === data.id) ? this.toastList.find(x => x.id === data.id).trigger : null
      if (!data.isConfirm) {
        this.delToast(data.id)
      } else {
        if (trigger) {
          if (trigger === 'closeToast') {
            this.delToast()
          }
        } else {
          alert(this.locale.alert_system_error)
        }
      }
    },
    validateOnSubmit () {
      if (this.isBlank) {
        return false
      } else {
        return true
      }
    },
    onSubmit () {
      const locale = this.locale
      const isPassed = this.validateOnSubmit()
      const data = {
        uid: this.uid,
        pw: this.password
      }
      if (isPassed) {
        this.$store.commit('loading', true)
        this.$store.dispatch('authentication/login', data)
          .then((res) => {
            if (res && res.status === 200 && res.data && res.data.status && res.data.status === 200) {
              this.$store.commit('authentication/setLogin', this.uid.split('.')[0])
              if (this.historyBack) {
                this.$router.push(this.historyBack)
              } else {
                this.$router.push({
                  name: 'main'
                })
              }
            } else if ((res && res.status === 403) || (res && res.response && res.response.status === 403) || (res && res.data && res.data.status !== 200)) {
              this.addToast('closeToast', 'alert', locale.login_wrong)
            } else {
              this.addToast('closeToast', 'alert', locale.alert_system_error)
            }
            this.$store.commit('loading', false)
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  padding-bottom: 5%;
  text-align: center;
  font-size: 20px;
  .loginFrame {
    width: 100%;
    max-width: 400px;
    padding: 30px 15px 120px;
  }
  .input {
    border-radius: 8px;
  }
  .btn {
    border-radius: 8px;
  }
}
h1 {
  font-size: 20px;
  &:before {
    content: "";
    display: block;
    height: 64px;
    margin-bottom: 30px;
    background: url('~@/assets/img/ico_lock.png') 50% 50% / contain no-repeat;
    opacity: 0.15;
  }
}
h2 {
  color: $color-grey;
}
.loginForm {
  margin-top: 30px;
}
.uid {
  margin-bottom: 10px;
}
.upw {
  margin-bottom: 10px;
}
@media screen and (min-width: 768px) {
  .login {
    min-height: 100vh;
  }
}
</style>
